import { Button, ButtonSizeLG } from '@picsart/button';
import IconDelete from '@picsart/icons/IconDelete';
import { Spacings } from '@picsart/cascade';
import noop from '@picsart/rc/noop';
import { useTranslator } from '@picsart/rc/services/localization';
import View from '@picsart/view/View';

import useBatchData from 'pages/Batch/sections/Context/useBatchData';
import { PreviewModalImage, PreviewModalImageBox, PreviewModalZoomWrapper, PreviewModalZoomDesktopActions } from 'pages/Batch/components/PreviewModal/ModalSlices';

interface IBasicModalContentProps {
    imageSrc: string;
    withDeleteAction?: boolean;
    onDeleteImage?: () => void;
}
const BasicModalContent = ({ imageSrc, withDeleteAction, onDeleteImage = noop }: IBasicModalContentProps) => {
  const { isWeb } = useBatchData();
  const translate = useTranslator();

  return (
    <>
      <PreviewModalImageBox>
        <PreviewModalZoomWrapper>
          <PreviewModalImage imageSrc={imageSrc} />
        </PreviewModalZoomWrapper>
      </PreviewModalImageBox>
      <PreviewModalZoomDesktopActions />
      { !isWeb && withDeleteAction && (
        <View padding={Spacings.s16} paddingBlockStart={Spacings.s0}>
          <Button onClick={onDeleteImage} size={ButtonSizeLG} isFullWidth startIcon={IconDelete}>{translate('Delete image')}</Button>
        </View>
      )}
    </>
  );
};

export default BasicModalContent;
